//suspended.module.scss

import { useActionData, useSubmit, useLocation,useNavigate } from 'react-router-dom';

import tac from './info.module.scss'; 
import {logout} from '../../../components/dropdown';
import { useState, useEffect } from 'react';

export function susaction(){

}
export default function InfoUser({ state }) {
  //const { state } = useLocation();
  const submit = useSubmit();

  useEffect(()=>{

    setTimeout(()=>{ 
      window.localStorage.removeItem('baUid');
    },5000);
    document.getElementById('ba3').style.display="none";

  },[]);


  return (
    <>

    <div className={tac.topq}>

	    <div className={tac.img}> 
	        <img src="/wp-user/b/logo.png" onClick={() => {
          //window.location.href = '/wp-user/auth/'; 
          window.location.href = `//${window.location.hostname}`;
        }} />
	    </div>

	    <button className={tac.btn3} onClick={() => {
          logout();
          window.location.href = `//${window.location.hostname}`;
        }}>
	    logout
	    </button>

    </div>

        <div className={tac.tac}>
        <div className={tac.card}>
          <div className={tac.icon}></div>
          <div className={tac.hea} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>{state?.head?state?.head:''}</div>
 
          <div className={tac.txt} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>
          {state?.body?state?.body:''} </div>

          <div className={tac.btn} onClick={() => {
          logout();
          window.location.href = `//${window.location.hostname}`;
        }}>Logout</div>



        </div></div> 
</>
);

}